import { RootState } from '@/store/store';
import { GetterTree } from 'vuex';
import { CoursePackageState } from './course-package.types';

export const coursePackageGetters: GetterTree<CoursePackageState, RootState> = {
  hasPricedCoursePackages(state): boolean {
    const activeCoursePackages =
      state.coursePackageTabState.activeCoursePackages;
    if (!activeCoursePackages || activeCoursePackages.length === 0) {
      return false;
    }

    return activeCoursePackages.some((pkg) => {
      if (pkg.amount !== undefined && pkg.amount !== null) {
        return Number(pkg.amount) > 0;
      }
    });
  },

  pricedCoursePackageCount(state): number {
    const activeCoursePackages =
      state.coursePackageTabState.activeCoursePackages;
    if (!activeCoursePackages || activeCoursePackages.length === 0) {
      return 0;
    }

    return activeCoursePackages.filter((pkg) => pkg.amount > 0).length;
  }
};
